import type { TouchEvent } from 'react';
import { useRef } from 'react';

export function useLongPress(
  handler: () => void,
  { duration = 500 }: { duration?: number } = {},
) {
  let timer: NodeJS.Timeout;

  const target = useRef<HTMLElement>();

  const onTouchStart = (e: TouchEvent) => {
    e.stopPropagation();

    if (e.target instanceof HTMLElement) {
      target.current = e.target;
      target.current.style.userSelect = 'none';
      target.current.style.webkitUserSelect = 'none';
    }
    timer = setTimeout(() => {
      handler();
    }, duration);
  };

  const onTouchMove = () => {
    if (timer) {
      clearTimeout(timer);
    }
  };

  const onTouchEnd = (e: TouchEvent) => {
    e.stopPropagation();

    if (timer) {
      clearTimeout(timer);
    }

    if (target?.current) {
      target.current.style.userSelect = 'none';
      target.current.style.webkitUserSelect = 'none';
    }
  };

  return {
    onTouchEnd,
    onTouchMove,
    onTouchStart,
  };
}
